import { Graphics, Container, FillGradient, Sprite, Ticker, Texture, TextureSource, Rectangle, Filter, Spritesheet, Color, Point } from 'pixi.js';
import { app, fixedWidth } from '../app';
import { interpColour } from '../utils/customMaths';
import { ColorReplaceFilter } from 'pixi-filters';
import { getTexture } from '../assets/assets';
import { findSettingByID, settingValue } from '../settings';
import { currentPalette } from '../palettes';
import { Colourise } from '../assets/filters/Colourise';
import { NormalFilter } from '../assets/filters/NormalFilter';
import { heldDuration, mouseDown, mousePos } from '../screens/default';


const DEFAULT_STRIPE_NUMBER = 12;

// let STRIPE_NUMBER = 12; //less is better performance... <11/12 really destroys wave illusion, disable wave effects under this number



const BACKGROUND_COLOUR_1  = 0x777777;
const DETAIL_COLOUR_1 = 0x000000;
const DETAIL_COLOUR_2 = 0x440000;

type BackgroundSettings = {
    stripeNumber: number;
    bob: boolean;
    bobAmount: number;
    bobSpeed: number;
    wobbleEnabled: boolean;
    wobbleAmount: number;
    wobbleWavelength: number;
    wobbleSpeed: number;
    waveSway: number;
    swayAmount: number;
    bitRotation: boolean;
    backgroundAlpha: number;
    wavelength: number;
    amplitudeMult: number;
    verticalSpeed: number;
    horizontalOffset: number;
    rateOfChange: number;
    extra: boolean;
    extraMult: number;
    waveFidelity: number;
    halfFidelity: number;
    refreshRate: number;
    bitPositioning: boolean;
}

const backgroundDefault: BackgroundSettings = {
    stripeNumber: DEFAULT_STRIPE_NUMBER,
    bob: false,
    bobAmount: 0,
    bobSpeed: 0,
    wobbleEnabled: false,
    wobbleAmount:0,
    wobbleWavelength: 0,
    wobbleSpeed: 0,
    waveSway: 0,
    swayAmount: 0,
    bitRotation: false,
    backgroundAlpha: 0,
    wavelength: 0,
    amplitudeMult: 0,
    verticalSpeed: 0,
    horizontalOffset: 0,
    rateOfChange: 0,
    extra: false,
    extraMult: 50,
    waveFidelity : 0,
    halfFidelity : 0,     
    refreshRate : 0,
    bitPositioning :  true
}

export class Background extends Container {

    public container = new Container();
    public stripes: Stripe[] = [];
    public settings: BackgroundSettings = backgroundDefault;
    // public tintModes: Container[] = [new Container, new Container, new Container];

    constructor () {

        super()
        this.container.sortableChildren = true;

        this.createStripes(); //create once on startup
        this.updateSettings();

        // // this.tintModes[0].filters = new Colourise(currentPalette.back1, currentPalette.back2);
        // // // this.tintModes[0].alpha = 0
        // // // this.tintModes[1].alpha = 0
        // // // this.tintModes[2].alpha = 0
        // // this.tintModes[1].filters = new Colourise(currentPalette.back1, currentPalette.back2);
        // // this.tintModes[2].filters = new Colourise(currentPalette.back1, currentPalette.back2);
       
        // this.tintModes.forEach(mode => {
        //     mode.zIndex = 100;
        //     this.container.addChild(mode)
        //     mode.filters = new Colourise(currentPalette.back1, currentPalette.back2);
        //     mode.filterArea = new Rectangle(0,0,app.screen.width, app.screen.height);
        // })

        //  app.ticker.add(()=> {
        //   this.tintModes.forEach(mode => {
        //     mode.filters = new Colourise(currentPalette.back2, currentPalette.back1);
        // })  
        // })

        this.addChild(this.container);
    }

    createStripes(){
        for (let i = 0; i < this.settings.stripeNumber + 4 ; i++) {
            const stripe = new Stripe(i, 20, '0x660000', false, this.container, this);
            
            this.stripes.push( stripe);
            this.container.addChild(stripe)
            
        }
    }

    updateSettings(){
        const oldStripes = this.settings.stripeNumber;
        const newStripes = settingValue(findSettingByID(3)) ?? DEFAULT_STRIPE_NUMBER
        if (oldStripes !== newStripes) {
            this.stripes.splice(0).forEach(stripe => {
                stripe.killTicker();
                stripe.destroy()
            })
            this.settings.stripeNumber = settingValue(findSettingByID(3)) ?? DEFAULT_STRIPE_NUMBER
            this.createStripes()
        }
        const wwlv = settingValue(findSettingByID(8)) 
        const wv = settingValue(findSettingByID(22))
        const fullFidelity = (settingValue(findSettingByID(28)) ?? 25);
        this.settings = {...this.settings,
            bob: (settingValue(findSettingByID(12)) ?? 0) === 1,
            bobAmount: (settingValue(findSettingByID(13))  ?? 50)/100,
            bobSpeed: ( settingValue(findSettingByID(14))  ?? 50)/25,
            wobbleEnabled: settingValue(findSettingByID(6)) === 1,
            wobbleAmount:(settingValue(findSettingByID(7)) ?? 0) /200,
            wobbleWavelength: wwlv ? Math.log(wwlv)*5: 0,
            wobbleSpeed: (settingValue(findSettingByID(27)) ?? 20)/10,
            waveSway: settingValue(findSettingByID(9))?? 0,
            swayAmount: (settingValue(findSettingByID(10))?? 0)/5,
            bitRotation:(settingValue(findSettingByID(11))?? 1 ) === 1,
            backgroundAlpha :(settingValue(findSettingByID(5))?? 7)/10,
            wavelength:wv? 1/Math.log10(wv)*0.03 : 1,
            amplitudeMult : (settingValue(findSettingByID(23)) ?? 50)/50,
            verticalSpeed : (settingValue(findSettingByID(24)) ?? 50)/25,
            horizontalOffset : (settingValue(findSettingByID(25)) ?? 50)/65,
            rateOfChange : (settingValue(findSettingByID(26)) ?? 50)/10,
            extra : (settingValue(findSettingByID(4)) ?? 0) === 1,
            extraMult: (settingValue(findSettingByID(21)) ?? 50)/50,
            waveFidelity : fullFidelity,
            halfFidelity : fullFidelity/2,
            refreshRate : 1000/(settingValue(findSettingByID(34))?? 60),
            bitPositioning :  (settingValue(findSettingByID(29)) ?? 1) === 1
        }
    }

    public updateBits(){
        this.stripes.forEach(stripe => stripe.updateBits())
    }

    public resetBits(){
        this.stripes.forEach(stripe => stripe.resetBits())
    }

}

type Bit = {
        sprite: Sprite;
        // normal?: Sprite | undefined;
        baseY: number;
        weight: number;
        rotationSheet?: Texture[] | undefined;
        flipX: boolean;
        held: number;
        baseScale: number;
    }

class Stripe extends Container {

    

    private id;
    private number; //stripe number
    private g;
    private waveY = 0;
    private perY = 0.0;
    private offsetY = 0;
    private phase = 0;
    private colourFilter = new ColorReplaceFilter();
    // private bitFilter = new ColorReplaceFilter();
    private container: Container;
    private allBits = new Container;
    private tintModes: Container[] = [new Container, new Container, new Container, new Container]
    private tintFilters: (Filter| undefined)[];
    private bits: Bit[] = [];
    private update;
    private background: Background;
    

    constructor(id: number, number: number, colour: string, isTop: boolean, container: Container, background: Background) {
        super();

        this.id = id;
        this.g = new Graphics();

        //filters

        this.filters = [this.colourFilter]
        this.colourFilter.originalColor = BACKGROUND_COLOUR_1;
        this.colourFilter.tolerance = 1.0;

        this.tintFilters =  [
            undefined,
            new Colourise(0xffffff,0xffffff,0xffffff),
            new Colourise(0xffffff,0xffffff,0xffffff),
            new NormalFilter()
        ]
        this.tintModes[1].filters = this.tintFilters[1];
        this.tintModes[2].filters = this.tintFilters[2];
        // this.tintModes[3].filters = this.tintFilters[3]; //normal filter
        
        // this.bitFilter.originalColor = 0x000000;
        // this.bitFilter.tolerance = 1.0;

        // this.g.roundPixels = true;
        this.number = number;
        this.perY = (id-1)/background.settings.stripeNumber;

        this.container = container;
        this.background = background;

        //container for bits
        this.background.container.addChild(this.allBits)
        this.tintModes.forEach(mode => {
            // mode.zIndex = 100;
            // this.background.tintModes[index].addChild(mode);
            this.allBits.addChild(mode)
        })
        // this.bitContainer.filters = [this.bitFilter];
        // this.bitContainer2.filters = [this.colourFilter]
        
        this.allBits.zIndex = 100;
        this.sortableChildren = true

        this.addChild(this.g);
        
        this.addBits();    
        
        let bitToMove: any[];
        bitToMove = [];
        
        let lastTick = 0;

        const globalPoint = new Point(0,0);

        this.update = (ticker: Ticker) => {

            lastTick += ticker.deltaMS;
            if (lastTick < this.background.settings.refreshRate) {
                return;
            } else {
                lastTick = 0;
            }

            this.phase += 0.004*this.background.settings.rateOfChange;

            const offsetBase = this.perY*8 + this.phase
            const dynOffset = Math.sin(offsetBase);
            const dynOffset2 = Math.sin(offsetBase + 90*Math.PI/180);
            const dynOffset3 = Math.sin(offsetBase + 100*Math.PI/180);
            const dynOffset4 = Math.sin(offsetBase +  85*Math.PI/180);
            const dynOffset5 = Math.sin(this.perY*16 + this.phase +  85*Math.PI/180);

            if ( this.perY < (1 + 2/background.settings.stripeNumber)) {
                this.perY += 0.0020 * this.background.settings.verticalSpeed ;
            } else {
                this.perY = -2/background.settings.stripeNumber;
            }

            const rawY = app.renderer.height * this.perY
            // const delayedY = app.renderer.height * (this.perY-0.45) 
            // this.y = rawY;
            this.y = this.background.settings.bob ? 
                20+ rawY * (0.95 + 0.1*(Math.sin(this.perY*Math.PI*3.1 + this.phase*this.background.settings.bobSpeed))*this.background.settings.bobAmount) :
                rawY;

            this.x = (60*680/fixedWidth)*dynOffset*this.background.settings.horizontalOffset - 25;
            
            //offset bit movement to give 'weight'
            // const xOffset = (-30*dynOffset2)*this.background.settings.horizontalOffset - 25 
            // this.bitContainer.x = xOffset;
            // this.bitContainer2.x = xOffset;

            // const yOffset = this.background.settings.bob ? 
            //     -10 *Math.sin(0.5*Math.PI/2 + this.phase*this.background.settings.bobSpeed)*(dynOffset)*this.background.settings.bobAmount:
            //     0;
            // this.bitContainer.y = yOffset;
            // this.bitContainer2.y = yOffset;
            
            

            if (this.background.settings.bitRotation && this.bits.length > 0) {
                bitToMove = [];
                for (let i = 0; i < 50; i++) {
                    bitToMove.push(this.bits.at(Math.floor(Math.random()*this.bits.length)) ?? undefined);
                }
                
            }
            if (this.background.settings.bitRotation && bitToMove != undefined && bitToMove.length > 0) {
                bitToMove.forEach(bit => {
                    bit.sprite.rotation += dynOffset/500
                })
                
            }

            const light = currentPalette.back1;
            const dark = currentPalette.back2;
            // const alt1 = currentPalette.alt1;
            // const alt2 = currentPalette.alt2;

            this.colourFilter.targetColor = interpColour(light, dark , Math.min(Math.max(0 , this.perY*0.9+0.1), 1.0));

            

            //tinting bits
            // this.allBits.alpha = Math.min(1, this.perY*5+0.5);
            
            // (this.tintFilters[1] as Colourise).colour = (false)? 
            //     interpColour(alt1, alt2 , Math.max(0.0, Math.min(1.0, this.perY+0.2))):
            //     interpColour(light, dark , Math.max(0.0, Math.min(1.0, this.perY-0.2)));
            (this.tintFilters[1] as Colourise).colour = interpColour(light, dark , Math.max(0.0, Math.min(1.0, this.perY-0.2)));
            (this.tintFilters[2] as Colourise).colour = interpColour(light, dark , Math.max(0.0, Math.min(1.0, this.perY+0.2)));

            //umm optimise this with a ticker during transition only
            
            (this.tintFilters[1] as Colourise).lightColour = light;
            (this.tintFilters[2] as Colourise).lightColour = light;
            (this.tintFilters[1] as Colourise).darkColour =dark;
            (this.tintFilters[2] as Colourise).darkColour = dark;

            // (this.tintFilters[3] as NormalFilter).mouse = [mousePos[0], mousePos[1]];
            // (this.tintFilters[3] as NormalFilter).spritePos = [0, this.y];
            // (this.tintFilters[3] as NormalFilter).totalAlpha = this.allBits.alpha;

            //  Math.max(0, Math.min(1.0, 0.0+(this.perY-0.2)/2)))

            this.zIndex = this.perY*100

            //drawing wave !!!
            //Wave drawing here!!!
            const width = app.renderer.width + 50;
            const height = app.renderer.height //increase performance by dividing by 4-5... pair with full opacity to hide seams
            const stripeHeight = height/background.settings.stripeNumber;
            const amplitude = 4+(8+height/50)*this.background.settings.amplitudeMult;
            
            this.g.clear();

            const startX = -160 ;
            const startY = 0;

            this.g.moveTo(startX, startY);

            let lastX = startX;

            const longWave = this.background.settings.wavelength * 1.5;
            const shortWave = this.background.settings.wavelength * 0.5;

            const xReq = width - startX
            
            for(let x= startX; x <= xReq; x+= this.background.settings.waveFidelity) {
                let y = Math.sin((x+200) * (this.background.settings.wavelength) + dynOffset3 + (this.background.settings.waveSway ? this.background.settings.swayAmount*(Math.sin(x*this.background.settings.wavelength + dynOffset4 )*-dynOffset5*0.4) : 0) ) * amplitude 
                     + (this.background.settings.wobbleEnabled ? Math.sin( x/this.background.settings.wobbleWavelength + this.phase*this.background.settings.wobbleSpeed)*amplitude*this.background.settings.wobbleAmount : 0) //woobble
                    + (this.background.settings.extra ? 
                       (Math.sin((x+200*this.phase) * (longWave) + dynOffset4 + (Math.sin(x*longWave + dynOffset )*-dynOffset2*0.5) ) * amplitude
                       - 3*Math.sin((x+100*this.phase*2.7) * (shortWave) + dynOffset4 + (Math.sin(x*longWave + dynOffset )*-dynOffset2*0.5) ) * amplitude)
                       *this.background.settings.extraMult
                       : 0)
                    ;
                if (this.perY > 1) {
                    const reduction = this.perY%1/(2/background.settings.stripeNumber)
                    y *= (1-reduction)
                }
                lastX = x;
                this.g.lineTo(x,y);

                // this.tintModes.forEach(mode => {
                //     mode.alpha = Math.min(1, this.perY*5+0.5)
                //     mode.y = this.y;
                //     mode.zIndex = this.zIndex + 1;
                //     mode.x = this.x;
                // })
                
                let yAdjust = 0;
                if (this.perY < 0)  {
                    yAdjust = (height+50)*this.perY*(0.8+Math.abs(this.perY));
                }
                this.allBits.y = this.y + yAdjust;
                
                
                this.allBits.zIndex = this.zIndex + 1;
                this.allBits.x = this.x;

                //bit positioning
                if (this.bits.length > 0) {
                    
                    this.bits.forEach(bit => {
                        //fitting to wave location
                        if (this.background.settings.bitPositioning) {
                            const oldY = bit.sprite.y - bit.baseY;
                            const xDist = bit.sprite.x - x;
                            if (xDist > -this.background.settings.halfFidelity && xDist  < this.background.settings.halfFidelity) {
                                const prox = Math.abs(xDist)/this.background.settings.halfFidelity;

                                bit.sprite.y = bit.baseY + oldY + prox*(y-oldY);
                            }
                        }
                        if (bit.rotationSheet !== undefined) {
                            // bit.sprite.rotation += 0.0004;
                            const length = bit.rotationSheet.length;
                            const sectLength = (360/bit.rotationSheet.length);
                            const angle = bit.flipX ? (360 - bit.sprite.angle + 180) % 360 : bit.sprite.angle;
                            const neededIndex = 
                                // bit.flipX ? 
                                // Math.abs((Math.round(((bit.sprite.angle) % 360)  / angle )   )%length) :
                                (length-1) - Math.abs((Math.round(((angle) % 360)  / sectLength )   )%length);
                                // console.log(neededIndex)
                            bit.sprite.texture = bit.rotationSheet[neededIndex]
                        }
                        // if (bit.normal) {
                        //     bit.normal.x = bit.sprite.x;
                        //     bit.normal.y = bit.sprite.y;
                        //     bit.normal.rotation = bit.sprite.rotation;
                        //     const encodedRot = (bit.normal.rotation % (Math.PI * 2)) / (Math.PI * 2) * 0.5;
                        //     bit.normal.alpha = 0.5 + encodedRot;
                        // }
                        //applying lighting to bits with normal maps
                        // if (bit.normal && bit.normal.filters && bit.normal.filters.length > 0) {
                        //     bit.normal.filters.forEach(filter => {
                        //         if (filter instanceof NormalFilter) {
                        //             filter.mouse = [mousePos[0], mousePos[1]];
                        //             filter.spritePos = [bit.container.x+this.x, bit.container.y+this.y]
                        //         }
                        //     })
                        // }
                        

                        //on-click animation
                        
                        const globalPos = bit.sprite.toGlobal(globalPoint);
                        const dx = globalPos.x - mousePos[0];
                        const dy = globalPos.y - mousePos[1];
                        const dist = Math.sqrt(dx*dx + dy*dy);
                        const cap = 50;
                        if (mouseDown && dist < bit.sprite.width/2) {
                            if ( bit.held < cap) {
                                bit.held += 0.02
                            }
                        } else if (bit.held > 0) {
                            bit.held -= 0.05
                            if (bit.held <0) bit.held = 0
                        }
                        
                        if (bit.held > 0) {
                            if (bit.held < cap) {
                                // if (bit.held < 0.1) console.log(bit.sprite.scale.x, bit.baseScale)
                                // if (bit.sprite.scale.x < 0) console.log("FLIPPED! "+bit.held)
                                bit.sprite.angle += (bit.held%21 -10)/100
                                // console.log(bit.flipX+", "+bit.sprite.angle)
                                // console.log(bit.rotationSheet)
                                if (mouseDown && dist < bit.sprite.width/2) {
                                    bit.sprite.scale.set(  bit.baseScale * (1+Math.sin(bit.held*Math.PI/cap)/5))
                                    if (bit.flipX) bit.sprite.scale.x *= -1;
                                } else if (bit.sprite.scale.x !== bit.baseScale) {
                                    bit.sprite.scale.set((bit.sprite.scale.x*199 +bit.baseScale)/200)
                                    if (bit.sprite.scale.x -  bit.baseScale < 0.001) {
                                        bit.sprite.scale.set(bit.baseScale)
                                    }
                                    if (bit.flipX) bit.sprite.scale.x *= -1;
                                }
                            }                           
                        }
                        
                        
                    })
                    
                }
                
            }

            
            this.g.lineTo(lastX, height*1.4);
            this.g.lineTo(startX, height*1.4);
            this.g.lineTo(startX -20, 0)

            this.g.fill(BACKGROUND_COLOUR_1);
            this.g.alpha = this.background.settings.backgroundAlpha;


            this.g.closePath();
                
            }

            
        app.ticker.add(this.update);
        
    }

    updateBits(){
        let weightTotal = 0;
        const bitSet = currentPalette.bits;
        const weightList: number[]  = [];
        const textureList: (Texture<TextureSource<any>> | Spritesheet | undefined)[] = [];

        bitSet.forEach((detail) => {
            let texture;
            if (detail.sprite) {
                texture = getTexture(detail.sprite);
            } else if (detail.rotationSheet) {
                texture = (getTexture(detail.rotationSheet))
                // texture = Object.values((getTexture(detail.rotationSheet) as Spritesheet).textures)[0] //get frame
                // console.log(getTexture(detail.rotationSheet))
                // console.log("Sprite sheet!")
                // console.log(texture)
            } else {
                texture = undefined; 
            }
            // if (texture === undefined) return;
            weightTotal += detail.weight;
            weightList.push(weightTotal) //find cumulative total for each item
            textureList.push(texture)
        })

        this.bits.forEach((bit) => {

            let hasTexture = true;
            const relativeWeight = bit.weight*weightTotal;
            let tier = -1;
            for (let i = 0; i < bitSet.length ; i++) {
                if (i === bitSet.length - 1) {
                    if (relativeWeight <= weightTotal) {
                        tier = i;
                    } else {
                        console.error("Error resolving detail sprite for following bitSet:")
                        console.error(bitSet);
                        return;
                    }
                } else {
                    if (relativeWeight <= weightList[i]) {
                        tier = i;
                        break;
                    }
                }
            }

            // console.log("Final tier: "+tier)

            // console.log(textureList[tier])

            if (textureList[tier] !== undefined) {
                if ( textureList[tier] instanceof Spritesheet) {
                    bit.rotationSheet = Object.values((textureList[tier] as Spritesheet).textures);
                    bit.sprite.texture = bit.rotationSheet[0] //change texture to spritesheet frame
                    // console.log(bit.rotationSheet)
                    // console.log(bit.sprite.texture)
                } else if (textureList[tier] instanceof Texture) {
                    bit.rotationSheet = undefined;
                    bit.sprite.texture = (textureList[tier] as Texture<TextureSource<any>>); //change texture to newly assigned sprite
                }
                
            } else {
                hasTexture = false;
            }
            

            if (bitSet[tier].scale && typeof bitSet[tier].scale === 'number') {
                bit.baseScale = (bitSet[tier].scale as number)
                if (bitSet[tier].variableScale && typeof bitSet[tier].variableScale === 'number') {
                    bit.baseScale += Math.random()*(bitSet[tier].variableScale as number)
                }
                
            } else {
                bit.baseScale = 0.2;
            }
            
            // bit.baseScale *= bit.flipX ? -1 :1;
            bit.sprite.scale = bit.baseScale
            if (bit.flipX) bit.sprite.scale.x *= -1;


            //normal map filters, if any
            // const normalRef = bitSet[tier].normal;
            // const normalContainer = this.tintModes[3];
            // if (normalRef) {
            //     const normalTexture = getTexture(normalRef);
            //     if (normalTexture) {
            //         if (!bit.normal) {
            //             bit.normal = Sprite.from(normalTexture);
            //             bit.normal.anchor = 0.5;
            //             bit.normal.scale = 0.2;
            //         } else if (bit.normal.texture !== normalTexture) {
            //             bit.normal.texture = normalTexture;
            //         }
                    
            //         //add to container
            //         if (!normalContainer.children.includes(bit.normal)) {
            //             this.tintModes[3].addChild(bit.normal);
            //         }
                    
            //     }
            // } else {
            //     if (bit.normal && normalContainer.children.includes(bit.normal)) {
            //         this.tintModes[3].removeChild(bit.normal);
            //     }
            // }

            const currentParent = bit.sprite.parent;
            if (hasTexture) {
                const targetTint = this.tintModes[bitSet[tier].colourMode]; 

                //re-assign tint mode
                if (currentParent !== targetTint) {
                    if (currentParent) {
                        currentParent.removeChild(bit.sprite);
                    }
                    targetTint.addChild(bit.sprite);
                }
            } else {
                if (currentParent) {
                    currentParent.removeChild(bit.sprite);
                }
            }
            
        })
    }

    addBits(){

        const texture = getTexture('seed') //default texture

        const bitPositioning = (settingValue(findSettingByID(29)) ?? 1) === 1;

        //creating bits
        const bitMode = settingValue(findSettingByID(2)) ?? 0;
        if (bitMode !== 2)
        for (let h = 0; h < bitMode + 1; h++) {
            for (let i = 0; i < 3; i++) {
                const randomX = Math.floor(Math.random()*100)
                for (let j = 0; j< 10; j++) {
                    if (texture) {
                        const bit = {sprite: Sprite.from(texture), baseY: 0, weight: Math.random(), flipX: Math.random() > 0.5 ? true: false, held: 0, baseScale: 0.2};
                        
                        bit.sprite.anchor = 0.5;
                        
                        // bit.sprite.zIndex = 100;
                        bit.sprite.x = randomX*2 + j*(40*(1+Math.random()));
                        bit.baseY =  bitPositioning ? 30 + i*i*10 + Math.random()*10 + h*3 :
                            30 - Math.sin(bit.sprite.x * 0.02) * 20 + i*i*10 + Math.random()*10 + h*3
                        bit.sprite.y = bit.baseY;
                        bit.sprite.scale = bit.baseScale;
                        
                        bit.sprite.rotation = Math.random()*360
                        this.bits.push(bit);
                    }
                }
                
            }
        }

        requestAnimationFrame(()=> this.updateBits())
        
    }

    public killTicker(){
        this.background.container.removeChild(this.allBits)
        this.tintModes.forEach(mode => {
            this.allBits.removeChild(mode)
        })
        app.ticker.remove(this.update);
    }

    resetBits(){
        
        this.tintModes.forEach(mode => {
            Array.from(mode.children).forEach(bit => bit.destroy());
        })
        this.bits = [];
        this.addBits()
    }
}

